/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

// [SC] - back to top - theme update
document.addEventListener("DOMContentLoaded", function () {
  var btn = document.getElementById("btt-button");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      btn.classList.add("show");
    } else {
      btn.classList.remove("show");
    }
  });

  btn.addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});

// [SC] - 18th Feb 2025 - Tab - theme update
document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".tab");
    const contents = document.querySelectorAll(".tab-content");

    tabs.forEach(tab => {
        tab.addEventListener("click", function () {
            // Remove active class from all tabs and contents
            tabs.forEach(t => t.classList.remove("active"));
            contents.forEach(c => c.classList.remove("active"));

            // Add active class to clicked tab and corresponding content
            this.classList.add("active");
            document.querySelector(`.tab-content[data-content="${this.dataset.tab}"]`).classList.add("active");
        });
    });
});

// [SC] - theme update - rebuy caused error's fix: product was being redirect to cart page on product pages even through it didn't redirect on other locations
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        form.addEventListener("submit", function (event) {
            event.preventDefault(); // Prevent default form submission

            let addToCartBtn = this.querySelector(".add-to-cart");
            let addToCartText = addToCartBtn.querySelector("span");
            let originalText = addToCartText.textContent; // Store original button text

            // Change button text to "Adding..."
            addToCartText.textContent = "Adding...";
            addToCartBtn.disabled = true; // Disable button temporarily

            let formData = new FormData(this);

            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                console.log("Product added:", data);
                
                // Show a confirmation message
                console.log("Product added to cart! and prevented from cart redirect");

                // Optional: Update the cart count dynamically
                fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    document.querySelector(".cart-link__bubble-num").textContent = cart.item_count;
                });

                // Revert button text after 3 seconds
                setTimeout(() => {
                    addToCartText.textContent = originalText;
                    addToCartBtn.disabled = false; // Re-enable button
                }, 3000);
            })
            .catch(error => {
                console.error("Error adding to cart:", error);
                addToCartText.textContent = originalText; // Revert text on error
                addToCartBtn.disabled = false;
            });
        });
    });
});

// [SC] - theme update - add_to_cart_grid function for the product in collection and featured sections
function add_to_cart_grid(button, variantid, qty) {
  if (!button) return;

  let originalText = button.innerHTML; 
  button.innerHTML = "<span>Adding...</span>";
  button.disabled = true; 

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantid,
      quantity: qty,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to add to cart");
      }
      return response.json();
    })
    .then((data) => {
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 3000);
    })
    .catch((error) => {
      console.log("Fail:", error);
      button.innerHTML = originalText;
      button.disabled = false;
    });
}